export enum AuditableModelType {
  FIELD = 'FIELD',
  SECTION = 'SECTION',
  MODEL = 'MODEL',
  GROUP = 'GROUP',
  CHALLENGE = 'CHALLENGE',
  TASK = 'TASK',
  USER = 'USER',
  LEVEL = 'LEVEL',
  PART = 'PART',
  SUBTOPIC = 'SUBTOPIC',
  TOPIC = 'TOPIC',
  SCHOOL = 'SCHOOL',
  INSTANCE_CONFIG_VALUE = 'INSTANCE_CONFIG_VALUE',
  PROOF_LINK = 'PROOF_LINK',
  PROOF_IMAGE = 'PROOF_IMAGE',
  PROOF_EXTERNAL_FILE = 'PROOF_EXTERNAL_FILE',
  RUBRIC_PROGRESS_VALUE = 'RUBRIC_PROGRESS_VALUE',
  LEVEL_PROGRESS_NOTE = 'LEVEL_PROGRESS_NOTE',
  LEVEL_PROGRESS_COACH_COMMENT = 'LEVEL_PROGRESS_COACH_COMMENT',
  PERSPECTIVE = 'PERSPECTIVE',
  COACH_COMMENT = 'COACH_COMMENT',
  ROW = 'ROW',
  TAG = 'TAG',
}

export enum AuditEventType {
  CREATE = 'CREATE',
  MODIFY = 'MODIFY',
  DELETE = 'DELETE',
}

export enum AuditEventSubtype {
  CHALLENGE_SHARE = 'CHALLENGE_SHARE',
  CHALLENGE_LEAVE = 'CHALLENGE_LEAVE',
  CHALLENGE_INVITE_ACCEPT = 'CHALLENGE_INVITE_ACCEPT',
  COACH_RUBRIC_PROGRESS_MOVE = 'COACH_RUBRIC_PROGRESS_MOVE',
  USER_PERSPECTIVE_COHORT_ATTACH = 'USER_PERSPECTIVE_COHORT_ATTACH',
  USER_PERSPECTIVE_COHORT_DETACH = 'USER_PERSPECTIVE_COHORT_DETACH',
  USER_GROUPS_CHANGE = 'USER_GROUPS_CHANGE',
  USER_MANAGED_GROUPS_CHANGE = 'USER_MANAGED_GROUPS_CHANGE',
  PORTFOLIO_TEMPLATE_MOVE = 'PORTFOLIO_TEMPLATE_MOVE',
  FIELD_PART_ADD = 'FIELD_PART_ADD',
  FIELD_PART_REMOVE = 'FIELD_PART_REMOVE',
  CHALLENGE_MODEL_MOVE = 'CHALLENGE_MODEL_MOVE',
  PERSPECTIVE_CHANGE_CATEGORY = 'PERSPECTIVE_CHANGE_CATEGORY',
  CHALLENGE_MOVE = 'CHALLENGE_MOVE',
  TASK_MOVE = 'TASK_MOVE',
  CHALLENGE_NAME_CHANGE = 'CHALLENGE_NAME_CHANGE',
  TASK_NAME_CHANGE = 'TASK_NAME_CHANGE',
  CHALLENGE_IS_PUBLIC_CHANGE = 'CHALLENGE_IS_PUBLIC_CHANGE',
  TASK_IS_PUBLIC_CHANGE = 'TASK_IS_PUBLIC_CHANGE',
  CHALLENGE_FIELD_CHANGE = 'CHALLENGE_FIELD_CHANGE',
  TASK_FIELD_CHANGE = 'TASK_FIELD_CHANGE',
  CHALLENGE_DATE_CHANGE = 'CHALLENGE_DATE_CHANGE',
  TASK_DATE_CHANGE = 'TASK_DATE_CHANGE',
  LOG_ENTRY_CREATE = 'LOG_ENTRY_CREATE',
  LOG_ENTRY_CHANGE = 'LOG_ENTRY_CHANGE',
  LOG_ENTRY_DELETE = 'LOG_ENTRY_DELETE',
  TAGS_ADD = 'TAGS_ADD',
  TAGS_REMOVE = 'TAGS_REMOVE',
  CHALLENGE_PROOF_LINK_ADD = 'CHALLENGE_PROOF_LINK_ADD',
  CHALLENGE_PROOF_LINK_DELETE = 'CHALLENGE_PROOF_LINK_DELETE',
  CHALLENGE_PROOF_IMAGE_ADD = 'CHALLENGE_PROOF_IMAGE_ADD',
  CHALLENGE_PROOF_IMAGE_DELETE = 'CHALLENGE_PROOF_IMAGE_DELETE',
  CHALLENGE_PROOF_EXTERNAL_FILE_ADD = 'CHALLENGE_PROOF_EXTERNAL_FILE_ADD',
  CHALLENGE_PROOF_EXTERNAL_FILE_DELETE = 'CHALLENGE_PROOF_EXTERNAL_FILE_DELETE',
  CHALLENGE_RUBRIC_PROGRESS_SET_STUDENT = 'CHALLENGE_RUBRIC_PROGRESS_SET_STUDENT',
  CHALLENGE_RUBRIC_PROGRESS_SET_COACH = 'CHALLENGE_RUBRIC_PROGRESS_SET_COACH',
  CHALLENGE_LEVEL_PROGRESS_NOTE_ADD = 'CHALLENGE_LEVEL_PROGRESS_NOTE_ADD',
  CHALLENGE_LEVEL_PROGRESS_NOTE_EDIT = 'CHALLENGE_LEVEL_PROGRESS_NOTE_EDIT',
  CHALLENGE_LEVEL_PROGRESS_NOTE_DELETE = 'CHALLENGE_LEVEL_PROGRESS_NOTE_DELETE',
  CHALLENGE_LEVEL_PROGRESS_COACH_COMMENT_ADD = 'CHALLENGE_LEVEL_PROGRESS_COACH_COMMENT_ADD',
  CHALLENGE_LEVEL_PROGRESS_COACH_COMMENT_EDIT = 'CHALLENGE_LEVEL_PROGRESS_COACH_COMMENT_EDIT',
  CHALLENGE_LEVEL_PROGRESS_COACH_COMMENT_DELETE = 'CHALLENGE_LEVEL_PROGRESS_COACH_COMMENT_DELETE',
  TASK_PROOF_LINK_ADD = 'TASK_PROOF_LINK_ADD',
  TASK_PROOF_LINK_DELETE = 'TASK_PROOF_LINK_DELETE',
  TASK_PROOF_IMAGE_ADD = 'TASK_PROOF_IMAGE_ADD',
  TASK_PROOF_IMAGE_DELETE = 'TASK_PROOF_IMAGE_DELETE',
  TASK_PROOF_EXTERNAL_FILE_ADD = 'TASK_PROOF_EXTERNAL_FILE_ADD',
  TASK_PROOF_EXTERNAL_FILE_DELETE = 'TASK_PROOF_EXTERNAL_FILE_DELETE',
  TASK_RUBRIC_PROGRESS_SET_STUDENT = 'TASK_RUBRIC_PROGRESS_SET_STUDENT',
  TASK_RUBRIC_PROGRESS_SET_COACH = 'TASK_RUBRIC_PROGRESS_SET_COACH',
  TASK_LEVEL_PROGRESS_NOTE_ADD = 'TASK_LEVEL_PROGRESS_NOTE_ADD',
  TASK_LEVEL_PROGRESS_NOTE_EDIT = 'TASK_LEVEL_PROGRESS_NOTE_EDIT',
  TASK_LEVEL_PROGRESS_NOTE_DELETE = 'TASK_LEVEL_PROGRESS_NOTE_DELETE',
  TASK_LEVEL_PROGRESS_COACH_COMMENT_ADD = 'TASK_LEVEL_PROGRESS_COACH_COMMENT_ADD',
  TASK_LEVEL_PROGRESS_COACH_COMMENT_EDIT = 'TASK_LEVEL_PROGRESS_COACH_COMMENT_EDIT',
  TASK_LEVEL_PROGRESS_COACH_COMMENT_DELETE = 'TASK_LEVEL_PROGRESS_COACH_COMMENT_DELETE',
  ROW_MOVE = 'ROW_MOVE',
  TASK_ASSIGNEE_ADD = 'TASK_ASSIGNEE_ADD',
  TASK_ASSIGNEE_REMOVE = 'TASK_ASSIGNEE_REMOVE',
  TASK_PERSPECTIVE_ATTACHMENT_SET = 'TASK_PERSPECTIVE_ATTACHMENT_SET',
  ADD_FILE = 'ADD_FILE',
  REMOVE_FILE = 'REMOVE_FILE',
  ADD_EXTERNAL_FILE = 'ADD_EXTERNAL_FILE',
  REMOVE_EXTERNAL_FILE = 'REMOVE_EXTERNAL_FILE',
  SET_THUMBNAIL = 'SET_THUMBNAIL',
  REMOVE_THUMBNAIL = 'REMOVE_THUMBNAIL',
}

export enum SecurityAuditEventType {
  LOGIN = 'LOGIN',
  LOGIN_FAILURE = 'LOGIN_FAILURE',
  UNAUTHORIZED = 'UNAUTHORIZED',
  FORBIDDEN = 'FORBIDDEN',
  ROLE_CHANGE = 'ROLE_CHANGE',
  ROLE_CHANGE_BULK = 'ROLE_CHANGE_BULK',
  ROLE_ESCALATION_ATTEMPT = 'ROLE_ESCALATION_ATTEMPT',
  USER_CREATE = 'USER_CREATE',
  USER_DELETE = 'USER_DELETE',
  USER_DELETE_BULK = 'USER_DELETE_BULK',
  INSTANCE_CONFIG_CHANGE = 'INSTANCE_CONFIG_CHANGE',
  ACCESS_ALL_USERS = 'ACCESS_ALL_USERS',
  ACCESS_ALL_GROUPS = 'ACCESS_ALL_GROUPS',
  ACCESS_PORTFOLIO_TEMPLATES_EDITOR = 'ACCESS_PORTFOLIO_TEMPLATES_EDITOR',
  ACCESS_CHALLENGE_MODEL_EDITOR = 'ACCESS_CHALLENGE_MODEL_EDITOR',
  ACCESS_AUDIT_EVENTS = 'ACCESS_AUDIT_EVENTS',
  ACCESS_SECURITY_AUDIT_EVENTS = 'ACCESS_SECURITY_AUDIT_EVENTS',
  COACH_VIEW_USER = 'COACH_VIEW_USER',
  SUSPICIOUS_REQUEST = 'SUSPICIOUS_REQUEST',
  SUSPICIOUS_VALUE_SUBMITTED = 'SUSPICIOUS_VALUE_SUBMITTED',
  UPLOADED_FILE_READY = 'UPLOADED_FILE_READY',
  UPLOADED_FILE_MALWARE_DETECTED = 'UPLOADED_FILE_MALWARE_DETECTED',
  UPLOADED_FILE_CONTAINS_INAPPROPRIATE_CONTENT = 'UPLOADED_FILE_CONTAINS_INAPPROPRIATE_CONTENT',
}
